import ScanAuditLog from './ScanAuditLog';

export default ScanAuditLog;
